export function getdata() {
	var obj = {
		headData: [{
				title: "纳税人类型",
				prop: "nsrlx",custom: true,
				width: "85"
			},
			{
				title: "所有权人纳税人识别号",
				prop: "suoyqNsrsbh",
				width: 170,
				custom: true,
			},
			{
				title: "所有权人名称",
				prop: "suoyqMc",
				width: 100,
				custom: true,
			},
			{
				title: "房产编号",
				prop: "fangcbh",
				width: 75,
				custom: true,
			},
			{
				title: "房产名称",
				prop: "fangcmc",
				width: 75,
				custom: true,
			},
			{
				title: "不动产权证号",
				prop: "budcqzh",
				width: 100,
				custom: true,
			},
			{
				title: "不动产单元代码",
				prop: "budcdydm",
				width: 110,
				custom: true,
			},
			{
				title: "房屋坐落地址",
				prop: "fangwzldz",
				width: 100,
				custom: true,
			},
			{
				title: "房产所属主管税务所",
				prop: "fangczgsws",
				custom: true,
				width: 160,
			},
			{
				title: "房屋所在土地编号",
				prop: "fangwsztdbh",
				custom: true,
				width: 160,
			},
			{
				title: "房产用途",
				prop: "fangcyt",
				width: 75,
				custom: true,
			},
			{
				title: "房产取得时间",
				prop: "fangcqdsj",
				custom: true,
				width: 100,
				
			},
			{
				title: "变更类型",
				prop: "bianglx",
				custom: true,
				width: "80"
			},
			{
				title: "变更时间",
				prop: "biangsj",
				custom: true,
				width: "80"
			},
			{
				title: "建筑面积",
				prop: "jianzmj",
				width: "80",
				custom: true,
				
			},
			{
				title: "出租房产面积",
				prop: "chuzfcmj",
				width: "110",
				custom: true,
				
			},
			{
				title: "房产原值",
				prop: "fangcyz",
				width: "90",
				AmountFormat: true,
				custom: true,
				
			},
			{
				title: "出租房产原值",
				prop: "chuzfcyz",
				width: "110",
				custom: true,
				
			},
			{
				title: "计税比例",
				prop: "jisbl",
				custom: true,
				width: "80"
			},
			{
				title: "月减免金额合计",
				prop: "yuejmjehj",
				width: "120",
				custom: true,
				
			},{
				title: "状态",
				prop: "caijFlag",
				width: "120",
				custom: true,
				align: "right"
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				custom: true,
				fixed: "right"
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		tabjson: '{  \"searchList\":[    {      \"name\":\"纳税人类型\",      \"column\":\"nsrlx\",      \"originName\":\"纳税人类型\",      \"show\":\"0\"    },    {      \"name\":\"所有权人纳税人识别号\",      \"column\":\"suoyqNsrsbh\",      \"originName\":\"所有权人纳税人识别号\",      \"show\":\"0\"    },    {      \"name\":\"所有权人名称\",      \"column\":\"suoyqMc\",      \"originName\":\"所有权人名称\",      \"show\":\"0\"    },    {      \"name\":\"房产编号\",      \"column\":\"fangcbh\",      \"originName\":\"房产编号\",      \"show\":\"0\"    },    {      \"name\":\"房产名称\",      \"column\":\"fangcmc\",      \"originName\":\"房产名称\",      \"show\":\"0\"    },    {      \"name\":\"房产用途\",      \"column\":\"fangcyt\",      \"originName\":\"房产用途\",      \"show\":\"0\"    },    {      \"name\":\"房产取得时间\",      \"column\":\"fangcqdsj\",      \"originName\":\"房产取得时间\",      \"show\":\"0\"    },{      \"name\":\"建筑面积\",      \"column\":\"jianzmj\",      \"originName\":\"建筑面积\",      \"show\":\"0\"    },    {      \"name\":\"房产原值\",      \"column\":\"fangcyz\",      \"originName\":\"房产原值\",      \"show\":\"0\"    },    {      \"name\":\"不动产权证号\",      \"column\":\"budcqzh\",      \"originName\":\"不动产权证号\",      \"show\":\"0\"    },    {      \"name\":\"不动产单元代码\",      \"column\":\"budcdydm\",      \"originName\":\"不动产单元代码\",      \"show\":\"0\"    },    {      \"name\":\"房屋坐落地址\",      \"column\":\"fangwzldz\",      \"originName\":\"房屋坐落地址\",      \"show\":\"0\"    },    {      \"name\":\"房产主管税务所\",      \"column\":\"fangczgsws\",      \"originName\":\"房产主管税务所\",      \"show\":\"0\"    },    {      \"name\":\"房屋所在土地编号\",      \"column\":\"fangwsztdbh\",      \"originName\":\"房屋所在土地编号\",      \"show\":\"0\"    },{      \"name\":\"本期应补退税额\",      \"column\":\"benqybtse\",      \"originName\":\"本期应补退税额\",      \"show\":\"0\"    },    {      \"name\":\"本期已缴税额\",      \"column\":\"benqyjse\",      \"originName\":\"本期已缴税额\",      \"show\":\"0\"    },    {      \"name\":\"六费两税减免税额\",      \"column\":\"liuslfjmse\",      \"originName\":\"六费两税减免税额\",      \"show\":\"0\"    },    {      \"name\":\"应纳税额\",      \"column\":\"yingnse\",      \"originName\":\"应纳税额\",      \"show\":\"0\"    },    {      \"name\":\"月减免金额合计\",      \"column\":\"yuejmjehj\",      \"originName\":\"月减免金额合计\",      \"show\":\"0\"    },    {      \"name\":\"变更类型\",      \"column\":\"bianglx\",      \"originName\":\"变更类型\",      \"show\":\"0\"    },    {      \"name\":\"变更时间\",      \"column\":\"biangsj\",      \"originName\":\"变更时间\",      \"show\":\"0\"    },    {      \"name\":\"出租房产面积\",      \"column\":\"chuzfcmj\",      \"originName\":\"出租房产面积\",      \"show\":\"0\"    },    {      \"name\":\"出租房产原值\",      \"column\":\"chuzfcyz\",      \"originName\":\"出租房产原值\",      \"show\":\"0\"    },    {      \"name\":\"计税比例\",      \"column\":\"jisbl\",      \"originName\":\"计税比例\",      \"show\":\"0\"    }  ],  \"headData\":[   {      \"name\":\"纳税人类型\",      \"column\":\"nsrlx\",      \"originName\":\"纳税人类型\",      \"show\":\"0\"    },    {      \"name\":\"所有权人纳税人识别号\",      \"column\":\"suoyqNsrsbh\",      \"originName\":\"所有权人纳税人识别号\",      \"show\":\"0\"    },    {      \"name\":\"所有权人名称\",      \"column\":\"suoyqMc\",      \"originName\":\"所有权人名称\",      \"show\":\"0\"    },    {      \"name\":\"房产编号\",      \"column\":\"fangcbh\",      \"originName\":\"房产编号\",      \"show\":\"0\"    },    {      \"name\":\"房产名称\",      \"column\":\"fangcmc\",      \"originName\":\"房产名称\",      \"show\":\"0\"    },    {      \"name\":\"房产用途\",      \"column\":\"fangcyt\",      \"originName\":\"房产用途\",      \"show\":\"0\"    },    {      \"name\":\"房产取得时间\",      \"column\":\"fangcqdsj\",      \"originName\":\"房产取得时间\",      \"show\":\"0\"    },{      \"name\":\"建筑面积\",      \"column\":\"jianzmj\",      \"originName\":\"建筑面积\",      \"show\":\"0\"    },    {      \"name\":\"房产原值\",      \"column\":\"fangcyz\",      \"originName\":\"房产原值\",      \"show\":\"0\"    },    {      \"name\":\"不动产权证号\",      \"column\":\"budcqzh\",      \"originName\":\"不动产权证号\",      \"show\":\"0\"    },    {      \"name\":\"不动产单元代码\",      \"column\":\"budcdydm\",      \"originName\":\"不动产单元代码\",      \"show\":\"0\"    },    {      \"name\":\"房屋坐落地址\",      \"column\":\"fangwzldz\",      \"originName\":\"房屋坐落地址\",      \"show\":\"0\"    },    {      \"name\":\"房产主管税务所\",      \"column\":\"fangczgsws\",      \"originName\":\"房产主管税务所\",      \"show\":\"0\"    },    {      \"name\":\"房屋所在土地编号\",      \"column\":\"fangwsztdbh\",      \"originName\":\"房屋所在土地编号\",      \"show\":\"0\"    },{      \"name\":\"本期应补退税额\",      \"column\":\"benqybtse\",      \"originName\":\"本期应补退税额\",      \"show\":\"0\"    },    {      \"name\":\"本期已缴税额\",      \"column\":\"benqyjse\",      \"originName\":\"本期已缴税额\",      \"show\":\"0\"    },    {      \"name\":\"六费两税减免税额\",      \"column\":\"liuslfjmse\",      \"originName\":\"六费两税减免税额\",      \"show\":\"0\"    },    {      \"name\":\"应纳税额\",      \"column\":\"yingnse\",      \"originName\":\"应纳税额\",      \"show\":\"0\"    },    {      \"name\":\"月减免金额合计\",      \"column\":\"yuejmjehj\",      \"originName\":\"月减免金额合计\",      \"show\":\"0\"    },    {      \"name\":\"变更类型\",      \"column\":\"bianglx\",      \"originName\":\"变更类型\",      \"show\":\"0\"    },    {      \"name\":\"变更时间\",      \"column\":\"biangsj\",      \"originName\":\"变更时间\",      \"show\":\"0\"    },    {      \"name\":\"出租房产面积\",      \"column\":\"chuzfcmj\",      \"originName\":\"出租房产面积\",      \"show\":\"0\"    },    {      \"name\":\"出租房产原值\",      \"column\":\"chuzfcyz\",      \"originName\":\"出租房产原值\",      \"show\":\"0\"    },    {      \"name\":\"计税比例\",      \"column\":\"jisbl\",      \"originName\":\"计税比例\",      \"show\":\"0\"    }  ],  \"formlist\":[    {      \"name\":\"纳税人类型\",      \"column\":\"nsrlx\",      \"originName\":\"纳税人类型\",      \"show\":\"0\"    },    {      \"name\":\"所有权人纳税人识别号\",      \"column\":\"suoyqNsrsbh\",      \"originName\":\"所有权人纳税人识别号\",      \"show\":\"0\"    },    {      \"name\":\"所有权人名称\",      \"column\":\"suoyqMc\",      \"originName\":\"所有权人名称\",      \"show\":\"0\"    },    {      \"name\":\"房产编号\",      \"column\":\"fangcbh\",      \"originName\":\"房产编号\",      \"show\":\"0\"    },    {      \"name\":\"房产名称\",      \"column\":\"fangcmc\",      \"originName\":\"房产名称\",      \"show\":\"0\"    },    {      \"name\":\"房产用途\",      \"column\":\"fangcyt\",      \"originName\":\"房产用途\",      \"show\":\"0\"    },    {      \"name\":\"房产取得时间\",      \"column\":\"fangcqdsj\",      \"originName\":\"房产取得时间\",      \"show\":\"0\"    },{      \"name\":\"建筑面积\",      \"column\":\"jianzmj\",      \"originName\":\"建筑面积\",      \"show\":\"0\"    },    {      \"name\":\"房产原值\",      \"column\":\"fangcyz\",      \"originName\":\"房产原值\",      \"show\":\"0\"    },    {      \"name\":\"不动产权证号\",      \"column\":\"budcqzh\",      \"originName\":\"不动产权证号\",      \"show\":\"0\"    },    {      \"name\":\"不动产单元代码\",      \"column\":\"budcdydm\",      \"originName\":\"不动产单元代码\",      \"show\":\"0\"    },    {      \"name\":\"房屋坐落地址\",      \"column\":\"fangwzldz\",      \"originName\":\"房屋坐落地址\",      \"show\":\"0\"    },    {      \"name\":\"房产主管税务所\",      \"column\":\"fangczgsws\",      \"originName\":\"房产主管税务所\",      \"show\":\"0\"    },    {      \"name\":\"房屋所在土地编号\",      \"column\":\"fangwsztdbh\",      \"originName\":\"房屋所在土地编号\",      \"show\":\"0\"    },{      \"name\":\"本期应补退税额\",      \"column\":\"benqybtse\",      \"originName\":\"本期应补退税额\",      \"show\":\"0\"    },    {      \"name\":\"本期已缴税额\",      \"column\":\"benqyjse\",      \"originName\":\"本期已缴税额\",      \"show\":\"0\"    },    {      \"name\":\"六费两税减免税额\",      \"column\":\"liuslfjmse\",      \"originName\":\"六费两税减免税额\",      \"show\":\"0\"    },    {      \"name\":\"应纳税额\",      \"column\":\"yingnse\",      \"originName\":\"应纳税额\",      \"show\":\"0\"    },    {      \"name\":\"月减免金额合计\",      \"column\":\"yuejmjehj\",      \"originName\":\"月减免金额合计\",      \"show\":\"0\"    },    {      \"name\":\"变更类型\",      \"column\":\"bianglx\",      \"originName\":\"变更类型\",      \"show\":\"0\"    },    {      \"name\":\"变更时间\",      \"column\":\"biangsj\",      \"originName\":\"变更时间\",      \"show\":\"0\"    },    {      \"name\":\"出租房产面积\",      \"column\":\"chuzfcmj\",      \"originName\":\"出租房产面积\",      \"show\":\"0\"    },    {      \"name\":\"出租房产原值\",      \"column\":\"chuzfcyz\",      \"originName\":\"出租房产原值\",      \"show\":\"0\"    },    {      \"name\":\"计税比例\",      \"column\":\"jisbl\",      \"originName\":\"计税比例\",      \"show\":\"0\"    }  ]}'
	}
	return obj
}
